import * as React from "react"


const Icon = ({className}: {className: string}) => {
    return     <svg width="54" height="40" viewBox="0 0 345 192" className={className} xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_230_2)">
                    <path d="M345 152.062H220.857L308.641 64.5092L280.331 36.2633L208.544 107.861V192H345V152.062Z"/>
                    <path d="M152.464 0V123.817L64.6794 36.2633L36.359 64.5092L124.143 152.062H0V192H152.464H172.485H192.506V0H152.464Z"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_230_2">
                    <rect width="345" height="192"/>
                    </clipPath>
                    </defs>
                </svg>
}

export default Icon